import { sendRequest } from '@widget/tool';
import Api from './api';

function Service() {
    let _this = this;
    let apis = [...Api];
    apis.forEach(item => {
        let { subUrl, name, method, showBusinessToast, showNetToast, showLoading } = item;
        _this[name] = (params = {}, headers = {}) => {
            return sendRequest({
                method: method,
                url: subUrl,
                noErrMsg: true,
                params: params,
                headers: headers,
                showNetToast: showNetToast,
                showBusinessToast: showBusinessToast,
                showLoading: showLoading,
                needCp: false
            });
        };
    });
}
export default new Service();
